<script setup lang="ts">
const bynderAssets = inject('bynderAssets')
</script>

<template>
  <LazyUiDialog
    name="brochure-and-downloads-dialog"
    dialog-type="responsive"
  >
    <template #dialogHeader>
      <span class="dialog__title">{{ $t('Brochure & downloads') }}</span>
    </template>

    <ul class="product-assets__list">
      <li
        v-for="asset in bynderAssets"
        :key="asset.src"
        class="product-assets__item"
      >
        <img
          v-if="asset.thumbnail"
          :src="asset.thumbnail"
          alt=""
          loading="lazy"
          fetchpriority="low"
          class="product-assets__thumbnail"
          height="200"
          width="200"
        >
        <div class="product-assets__content">
          <div class="product-assets__name">
            {{ asset.name }}
          </div>
        </div>
        <div class="product-assets__actions">
          <AppLink
            :to="asset.src"
            class="product-assets__download"
            download
          >
            <NuxtIcon name="icon:download" />
          </AppLink>
        </div>
      </li>
    </ul>

    <!--
      
    -->
  </LazyUiDialog>
</template>

<style>
@import url("~layers/components/Product/BrochureAndDownloadsDialog.css");
</style>
